import { gql } from "@apollo/client";

export const GET_EVENT_TYPE = gql`
  query getEventType {
    getEventType {
      id
      name
      description
    }
  }
`;

export const GET_EVENT = gql`
  query event($eventId: Int!) {
    event(event_id: $eventId) {
      id
      slug
      pass_image
      luxe
      event_preference {
        access_control
        oyple_integration
        plus_one_request
      }
      supported_currencies {
        currency
        providers
      }
      available_gift_payment_currencies {
        currency
        provider
      }
      enabled_currencies
      created_at
      default_currency_iso
      eventTimezone
    }
  }
`;

export const GET_EVENT_PREFERENCE = gql`
  query Event_preferences($eventId: UUID!) {
    event_preferences(event_id: $eventId) {
      access_control
      vendor_store
      dress_code
      asoebi_selection
      id
      event_id
      oyple_integration
      plus_one_request
      force_guest_app_download
    }
  }
`;

export const GET_EVENT_INFO = gql`
  query GetEventInfo($eventEventId2: Int!) {
    event(event_id: $eventEventId2) {
      id
      name
      hash_tag
      slug
      welcome_msg
      eventTimezone
      couple_details {
        first_name
        last_name
        image
        role
      }
      created_at
    }
  }
`;

export const GET_EVENTS_FOR_DASHBOARD = gql`
  query getEventsForDashboard($isInvited: Boolean, $page: Int, $pageSize: Int) {
    events(isInvited: $isInvited, page: $page, pageSize: $pageSize) {
      id
      uuid
      name
      event_type {
        name
      }
      couple_details {
        first_name
        last_name
        image
        role
      }
      luxe
      hero_image
      hero_image_thumbnail
      hash_tag
      slug
      toast
      date
      team {
        id
        user_uuid
        admin
        role
      }
      supported_currencies {
        currency
        providers
      }
      available_gift_payment_currencies {
        currency
        provider
      }
      enabled_currencies
      default_currency_iso
      event_parts {
        time
        address
        city
        state
        country
      }
      is_admin
      created_at
    }
  }
`;

export const EVENT_BY_SLUG = gql`
  query eventBySlug($slug: String!) {
    eventBySlug(slug: $slug) {
      template_id
    }
  }
`;

export const GET_INVITED_EVENTS_FOR_DASHBOARD = gql`
  query getInvitedEventsForDashboard(
    $isInvited: Boolean
    $page: Int
    $pageSize: Int
  ) {
    events(isInvited: $isInvited, page: $page, pageSize: $pageSize) {
      id
      uuid
      name
      event_type {
        name
      }
      couple_details {
        first_name
        last_name
        image
        role
      }
      hash_tag
      slug
      toast
      date
      hero_image
      hero_image_thumbnail
      event_parts {
        id
        uuid
        event_id
        name
        part
        time
        welcome_msg
        address
        created_at
        updated_at
      }
    }
  }
`;

export const GET_EVENT_BY_ID_DASHBOARD_LAYOUT = gql`
  query getEventByIdDashboardLayout(
    $isInvited: Boolean
    $page: Int
    $pageSize: Int
  ) {
    events(isInvited: $isInvited, page: $page, pageSize: $pageSize) {
      id
      name
      team {
        id
        user {
          first_name
          last_name
          uuid
          id
        }
        admin
        role
      }
    }
  }
`;

export const GET_EVENTS = gql`
  query events($isInvited: Boolean, $page: Int, $pageSize: Int) {
    events(isInvited: $isInvited, page: $page, pageSize: $pageSize) {
      id
      uuid
      name
      couple_details {
        first_name
        last_name
        image
        role
      }
      wallet_created
      hash_tag
      slug
      toast
      welcome_msg
      created_at
      updated_at
      date
      luxe
      hero_image
      hero_image_thumbnail
      event_wallet {
        id
        balance
        currency
        pin_is_set
        frozen
        created_at
        updated_at
      }
      team {
        id
        user_uuid
        event_id
        admin
        role
        user {
          first_name
          last_name
          image
        }
        created_at
        updated_at
      }
      event_type {
        id
        name
        description
      }
      event_parts {
        id
        uuid
        event_id
        name
        part
        time
        welcome_msg
        address
        city
        state
        country
        map_coordinate
        created_at
        updated_at
      }
      event_preference {
        id
        event_id
        food
        ads
        asoebi_selection
        gifts
        store
        vendor_store
        reservation
        dress_code
        map
        smart_send
        private
        live_hall
        created_at
        updated_at
        oyple_integration
        plus_one_request
      }
      is_admin
    }
  }
`;

export const GET_TEAM_MEMBER = gql`
  query getTeamMember($eventId: Int!) {
    getTeamMember(event_id: $eventId) {
      event_id
      user_uuid
      user {
        first_name
        id
        phone_number
        last_name
        verified
        email
        image
      }
      admin
      id
      role
    }
  }
`;

export const GET_VENDORS = gql`
  query eventVendor($eventId: Int!, $page: Int, $pageSize: Int) {
    eventVendor(event_id: $eventId, page: $page, pageSize: $pageSize) {
      id
      event_id
      instagram_handle
      role
      name
      email
      phone_number
      created_at
      updated_at
    }
  }
`;

export const CHECK_EVENT_SLUG = gql`
  query checkEventSlug($slug: String!) {
    checkEventSlug(slug: $slug)
  }
`;

export const GET_EVENT_STREAMERS = gql`
  query getEventStreamers($eventId: Int!) {
    getEventStreamers(eventId: $eventId) {
      Id
      event_uuid
      is_streaming
      playback_url
      ingest_endpoint
      stream_key
      deviceName
      viewingUrl
    }
  }
`;

export const EVENT_PARTS = gql`
  query eventParts($eventId: Int!) {
    eventParts(event_id: $eventId) {
      id
      uuid
      event_id
      name
      part
      time
      welcome_msg
      address
      city
      state
      country
      eventPartTimezone
      map_coordinate
      created_at
      updated_at
      geo_position {
        geo_position_id
        latitude
        longitude
      }
    }
  }
`;

export const GET_EVENT_PLAN = gql`
  query getEventPlan($eventId: Int!) {
    getEventPlan(event_id: $eventId) {
      website_template
      send_out_invites
      upload_pictures
      invitation_card
      event_id
      event_details
      build_invite_list
      categories
      add_wishlist
      hero_image
      asoebi
      event_schedule
      add_event_vendors
      add_back_story
      add_foreign_account
      add_live_hall
      seating_chart
      access_control
      custom_domain
    }
  }
`;

export const GET_CUSTOM_MY_PLAN_TASK = gql`
  query getCustomMyPlanTask($eventId: UUID!) {
    getCustomMyPlanTask(event_id: $eventId) {
      id
      event_id
      eventUUID
      name
      description
      done
      updated_at
      created_at
    }
  }
`;

export const GET_LIVE_SCHEDULES = gql`
  query getLiveSchedule($eventUuid: String!, $page: Int, $pageSize: Int) {
    getLiveSchedule(eventUuid: $eventUuid, page: $page, pageSize: $pageSize) {
      data {
        id
        event_uuid
        event_part_uuid
        link
        time
        created_at
        updated_at
        event_part {
          id
          name
          part
        }
      }
      page
      pageCount
      pageSize
      recordCount
    }
  }
`;

export const GET_MESSAGE = gql`
  query getMessageByUser($eventId: Int!, $page: Int, $pageSize: Int) {
    getMessageByUser(event_id: $eventId, page: $page, pageSize: $pageSize) {
      id
      content
      status
      event_id
      updated_at
      created_at
      user {
        first_name
        last_name
        phone_number
      }
    }
  }
`;

export const GET_MESSAGES_BY_EVENT = gql`
  query getMessagesByEvent($eventId: Int!, $page: Int, $pageSize: Int) {
    getMessagesByEvent(event_id: $eventId, page: $page, pageSize: $pageSize) {
      id
      event_id
      user {
        first_name
        last_name
        phone_number
      }
      content
      status
      created_at
      updated_at
    }
  }
`;

// Chapters queries

export const GET_BACK_STORY = gql`
  query getBackStory($eventId: Int!) {
    getBackStory(event_id: $eventId) {
      id
      role
      story
      title
      image
      event_id
    }
  }
`;

export const GET_WEDDING_PARTY = gql`
  query getWeddingParty($eventId: UUID!) {
    getWeddingParty(event_id: $eventId) {
      id
      first_name
      last_name
      nickname
      order_index
      role
      story
      image_url
      event_id
    }
  }
`;

// Wishlist queries

export const GET_WISHLIST_ITEMS = gql`
  query getWishListItems(
    $eventId: UUID!
    $listId: Int
    $page: Int
    $pageSize: Int
  ) {
    getWishListItems(
      event_id: $eventId
      listId: $listId
      page: $page
      pageSize: $pageSize
    ) {
      id
      name
      image
      link
      amount
      currency
      paid
      progress {
        target_amount
        amount_contributed
        amount_remaining
        percentage
        contributors_count
        goal_reached
        currency
      }
      created_at
      updated_at
    }
  }
`;

export const GET_WISHLIST_HISTORY = gql`
  query GetWishlistHistory($eventId: UUID!, $page: Int!) {
    getWishlistHistory(event_id: $eventId, page: $page) {
      gift_id
      wish_list_item_id
      currency
      amount
      wish_list_item {
        id
        name
        image
      }
      user {
        full_name
        email
        phone_number
      }
    }
  }
`;

export const GET_WISHLIST_NOTE = gql`
  query getWishlistNote($eventId: Int!) {
    event(event_id: $eventId) {
      wishlist_note
    }
  }
`;

// Media queries

export const GET_MEDIA_TAGS = gql`
  query Query {
    getMediaTags
  }
`;

export const GET_MEDIA = gql`
  query GetMedia($eventId: String!, $filter: MediaFilter!) {
    getMedia(event_id: $eventId, filter: $filter) {
      id
      name
      url
      tags
      type
      meta {
        s3_url
        height
        width
      }
      private
      user_id
      event_id
      album_id
      album {
        id
        name
        event_id
        description
        created_by
        creator {
          user_id
          username
          image
        }
        created_at
        updated_at
      }
      likes
      user_type
      order_index
      created_at
      updated_at
    }
  }
`;

export const GET_ALBUMS = gql`
  query GetAlbums($eventId: String!, $page: Int, $pageSize: Int) {
    getAlbums(event_id: $eventId) {
      data {
        id
        name
        event_id
        description
        created_by
        Media(page: $page, page_size: $pageSize) {
          data {
            album {
              created_at
              created_by
              name
            }
            created_at
            id
            event_id
            album_id
            name
            tags
            type
            url
          }
        }
        created_at
        updated_at
      }
    }
  }
`;

export const GET_GUEST_UPLOADS = gql`
  query GetPov($eventId: String!) {
    getPov(event_id: $eventId) {
      uploader {
        image
        user_id
        username
      }
      total_likes
      total_media_count
      total_videos
      total_pictures
      media {
        id
        name
        url
        tags
        type
        meta {
          s3_url
          height
          width
        }
        private
        user_id
        event_id
        album_id
        album {
          id
          name
        }
        likes
        user_type
        created_at
        updated_at
      }
    }
  }
`;

// Luxe queries

export const GET_LUXE_DETAILS = gql`
  query DescribeLuxe($event_id: UUID!) {
    describeLuxe(event_id: $event_id) {
      currency
      discount_percentage
      discounted_amount
      notes
      undiscounted_amount
    }
  }
`;

export const GET_ABANDONED_PAYMENT_REASONS = gql`
  query AbandonedPaymentReasons {
    abandonedPaymentReasons {
      reason
      label
    }
  }
`;

// Inawo pass queries
export const GET_INAWO_PASS_PROGRESS = gql`
  query GetInawoPassProgress($eventId: UUID!) {
    getInawoPassProgress(event_id: $eventId) {
      in_progress
      total_guest
      total_sent
    }
  }
`;

export const GET_EVENT_WEBSITE_VIEWS = gql`
  query GetEventWebsiteViews($eventId: UUID!) {
    getEventWebsiteViews(event_id: $eventId)
  }
`;

export const GET_EVENT_CACHE = gql`
  query GetEventCache($eventId: UUID!, $key: String!) {
    getEventCache(event_id: $eventId, key: $key) {
      version
      data
      hash
    }
  }
`;

export const GET_DOMAIN = gql`
  query Domain($domainId: UUID!) {
    domain(id: $domainId) {
      id
      user_id
      event_id
      domain_name
      status
      purchase_date
      expiry_date
      renewal_price
      purchase_price
      currency
      auto_renew
      dns_configured
      payment {
        id
        user_id
        domain_name
        tld
        years
        auto_renew
        registrar
        registrar_fee
        cloudflare_fee
        vercel_fee
        fee
        vat
        total_amount
        currency
        payment_processor
        payment_processor_reference
        payment_reference
        registrar_reference_id
        created_at
        updated_at
      }
      user {
        uuid
        id
        email
        first_name
        last_name
      }
      event {
        id
        uuid
        name
        slug
        luxe
      }
    }
  }
`;

export const GET_EVENT_DOMAINS = gql`
  query EventDomain($eventId: UUID!) {
    eventDomain(event_id: $eventId) {
      domains {
        id
        user_id
        event_id
        domain_name
        status
        purchase_date
        expiry_date
        renewal_price
        purchase_price
        currency
        auto_renew
        dns_configured
        created_at
        updated_at
        payment {
          id
          user_id
          domain_name
          tld
          years
          auto_renew
          registrar
          registrar_fee
          cloudflare_fee
          vercel_fee
          fee
          vat
          total_amount
          currency
          payment_processor
          payment_processor_reference
          payment_reference
          registrar_reference_id
          created_at
          updated_at
        }
        user {
          uuid
          id
          email
          first_name
          last_name
        }
        event {
          id
          uuid
          name
          slug
          luxe
        }
      }
      total
    }
  }
`;

export const EVENT_CUSTOM_DOMAIN_STATUSES = gql`
  query EventCustomDomainStatuses($eventId: UUID!) {
    eventCustomDomainStatuses(event_id: $eventId) {
      domain_name
      status
    }
  }
`;

export const SUGGEST_DOMAINS = gql`
  query SuggestDomains($domainName: String!, $tlds: [String!], $limit: Int) {
    suggestDomains(domain_name: $domainName, tlds: $tlds, limit: $limit) {
      domain
      available
      price
      currency
      premium
    }
  }
`;

export const CHECK_DOMAIN_AVAILABILITY = gql`
  query CheckDomainAvailability($domainName: String!) {
    checkDomainAvailability(domain_name: $domainName) {
      available
      price
      currency
      premium
    }
  }
`;

export const CHECK_DOMAIN_AVAILABILITY_MANY = gql`
  query CheckDomainAvailabilityMany($domainNames: [String!]!) {
    checkDomainAvailabilityMany(domain_names: $domainNames) {
      available
      price
      currency
      premium
    }
  }
`;

export const MY_DOMAINS = gql`
  query MyDomains {
    myDomains {
      domains {
        id
        user_id
        event_id
        domain_name
        status
        purchase_date
        expiry_date
        renewal_price
        purchase_price
        currency
        auto_renew
        dns_configured
        created_at
        updated_at
        payment {
          id
          user_id
          domain_name
          tld
          years
          auto_renew
          registrar
          registrar_fee
          cloudflare_fee
          vercel_fee
          fee
          vat
          total_amount
          currency
          payment_processor
          payment_processor_reference
          payment_reference
          registrar_reference_id
          created_at
          updated_at
        }
        user {
          uuid
          id
          email
          first_name
          last_name
        }
        event {
          id
          uuid
          name
          slug
          luxe
        }
      }
      total
    }
  }
`;

export const DOMAIN_HISTORY = gql`
  query DomainHistory($domainId: UUID!) {
    domainHistory(domain_id: $domainId) {
      id
      domain_id
      event_id
      attached_at
      detached_at
      attached_by
      detached_by
      detach_reason
      domain {
        id
        user_id
        event_id
        domain_name
        status
        purchase_date
        expiry_date
        renewal_price
        purchase_price
        currency
        auto_renew
        dns_configured
        user {
          uuid
          id
          email
          first_name
          last_name
        }
      }
      event {
        id
        uuid
        name
        slug
        luxe
      }
      attached_by_user {
        uuid
        first_name
        last_name
        email
      }
      detached_by_user {
        uuid
        first_name
        last_name
        email
      }
    }
  }
`;

export const GET_EVENT_RECOMMENDATION_LISTS = gql`
  query GetEventRecommendationLists($eventId: UUID!) {
    getEventRecommendationLists(eventId: $eventId) {
      id
      name
      category
      description
      items {
        id
        name
        description
        contactInfo
        link
        mediaUrl
        mediaType
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_RECOMMENDATION_LIST_DETAILS = gql`
  query GetRecommendationListDetails($listId: UUID!) {
    getRecommendationListDetails(listId: $listId) {
      id
      name
      category
      description
      items {
        id
        name
        description
        contactInfo
        link
        mediaUrl
        mediaType
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_GUEST_WESITE_STARTER_PROMPT = gql`
  query GetGuestWebsiteStarterPrompt($event_id: UUID!) {
    getGuestWebsiteStarterPrompt(event_id: $event_id)
  }
`;

export const GET_GUEST_WEBSITE_CHAT = gql`
  query GetGuestWebsiteChat($eventId: UUID!) {
    getGuestWebsiteChat(event_id: $eventId) {
      status
      preview_url
      summary
      error
      turns_left
      history {
        role
        content
        preview_url
        version
      }
    }
  }
`;

export const GET_TEAM_MEMBER_BY_INVITE_TOKEN = gql`
  query getTeamMemberByInviteToken($inviteToken: String!) {
    getTeamMemberByInviteToken(inviteToken: $inviteToken) {
      id
      event_id
      event_uuid
      email
      phone_number
      first_name
      last_name
      owner_role
      sent_status
    }
  }
`;

export const GET_WISHLIST_CONTRIBUTIONS = gql`
  query WishlistContributions($eventId: UUID!, $itemId: UUID!) {
    getWishListItemContributions(
      event_id: $eventId
      wish_list_item_id: $itemId
    ) {
      item {
        id
        event_id
        name
        image
        link
        paid
        created_at
        updated_at
        amount
        currency
      }
      progress {
        target_amount
        amount_contributed
        amount_remaining
        percentage
        contributors_count
        goal_reached
        currency
      }
      contributions {
        id
        full_name
        note
        amount
        currency
        payment_method
        status
        created_at
      }
    }
  }
`;
export const EVENT_TEAM_ROLES = gql`
  query EventTeamRoles($eventId: UUID!) {
    ownerTypes(event_id: $eventId)
  }
`;
